export default {
      id: "ic_im-usage",
      viewBox: "0 0 16 15",
      url: "/" + "images/icons.3.109.2.svg#ic_im-usage",
      toString: function () {
        return this.url;
      }
    }